import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'case'
})
export class CasePipe implements PipeTransform {

	public transform(text: string): string {
		if (!text)
			return null;
		let words = text.split(" ");
		for (let i = 0; i < words.length; i++) {

			let word = words[i];

			if (i > 0 && this.ispreposition(word)) {
				words[i] = word.toLowerCase();
			} else {
				if (this.containsSpecialChars(word)) {
					let subWords = word.split("/");
					for (let j = 0; j < subWords.length; j++) {
						subWords[j] = this.toUpperCase(subWords[j]);
					}
					words[i] = subWords.join("/");
				} else {
					words[i] = this.toUpperCase(word);
				}
			}

		}

		return words.join(' ');
	}

	private ispreposition(word: string) {

		const prepositions = ['of', 'the', 'a', 'to'];

		return prepositions.includes(word.toLowerCase());

	}

	private toUpperCase(word: string) {

		return word.substring(0, 1).toUpperCase() + word.substring(1).toLowerCase()

	}

	private containsSpecialChars(str: string): boolean {
		const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
		return specialChars.test(str);
	}
}